import React, { createContext, useState } from "react";

export const SearchReportContext = createContext({});

export const initialSearchValues = {
  projectName: "",
  departmentId: "",
  divisionId: "",
  monthOfBudget: "",
  yearOfBudget: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  // total: 0,
  // totalPage: 0,
  // sortBy: "departmentId",
  // sortDirection: "ASC"
};

const SearchPerfomanceProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchReportContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchReportContext.Provider>
  );
};

export default SearchPerfomanceProvider;
